module.exports = __webpack_public_path__ + "static/media/Delete_Icon.50602d3b.svg";